// JavaScript
import "../styles/front-end.scss";

import { initBodyScroll, killBodyScroll } from "./common/overlayScrollbars.js";
import { OverlayScrollbars } from "overlayscrollbars";
import { slideToggle } from "@roghz/slidetoggle";
import Cookies from "js-cookie";
import "./animate.js";

document.addEventListener("DOMContentLoaded", function () {
    const appHeight = () => {
        const doc = document.documentElement;
        doc.style.setProperty("--app-height", `${window.innerHeight}px`);
        doc.style.setProperty("--app-width", `${window.innerWidth}px`);
    };
    window.addEventListener("resize", appHeight);
    window.addEventListener("scroll", appHeight);
    appHeight();

    // Simple header animation trigger
    const siteHeader = document.querySelector('.site-header');
    if (siteHeader && window.matchMedia('(min-width: 1024px)').matches) {
        setTimeout(() => {
            siteHeader.classList.add('header--animated');
        }, 100);
    }

    const siteLogo = document.querySelector('.site-header__logo');
    const mobileNav = document.querySelector('.site-header__nav');
    const navWrapper = document.querySelector('.site-header__nav--scroll');
    const hamburger = document.getElementById('hamburger');
    const desktopClose = document.querySelector('.site-header__nav--close');
    const menuItems = document.querySelectorAll('.menu > .menu-item');

    // Search toggle in header
    const headerSearch = document.querySelector('.site-header__search');
    const openSearchBtn = document.getElementById('open-search');
    const closeSearchBtn = document.getElementById('close-search');
    const searchForm = headerSearch?.querySelector('form');

    const isHidden = (el) => {
        if (!el) return true;
        const cs = window.getComputedStyle(el);
        return cs.display === 'none' || cs.visibility === 'hidden';
    };

    const updateSearchButtons = () => {
        if (!openSearchBtn || !closeSearchBtn || !searchForm) return;
        const formHidden = isHidden(searchForm);
        openSearchBtn.classList.toggle('hidden', !formHidden);
        closeSearchBtn.classList.toggle('hidden', formHidden);
        openSearchBtn.setAttribute('aria-expanded', String(!formHidden));
      headerSearch.classList.toggle('active', !formHidden);

    };

    if (openSearchBtn && closeSearchBtn && searchForm) {
        // Initialize correct state on load
        updateSearchButtons();

        openSearchBtn.addEventListener('click', (e) => {
            e.preventDefault();
            // Open: ensure buttons reflect opening state
            openSearchBtn.classList.add('hidden');
            closeSearchBtn.classList.remove('hidden');
            openSearchBtn.setAttribute('aria-expanded', 'true');
          headerSearch.classList.add('active');

          slideToggle(searchForm, 300, 'block');
        });

        closeSearchBtn.addEventListener('click', (e) => {
            e.preventDefault();
            // Close: ensure buttons reflect closing state
            closeSearchBtn.classList.add('hidden');
            openSearchBtn.classList.remove('hidden');
            openSearchBtn.setAttribute('aria-expanded', 'false');
          headerSearch.classList.remove('active');
            slideToggle(searchForm, 300, 'block');
        });
    }

    let navScrollInstance = null;

    // Helper to reset all child-submenus under a given container
    const resetChildSubmenus = (container) => {
        if (!container) return;
        container.querySelectorAll('.child-nav-link.active').forEach(link => {
            link.classList.remove('active');
        });
        container.querySelectorAll('.child-submenu').forEach(ul => {
            ul.style.display = 'none';
        });
    };

    // Function to close all menu items (top-level + children)
    const closeAllMenuItems = () => {
        menuItems.forEach(item => {
            const link = item.querySelector('.nav-link');
            const submenu = item.querySelector('.submenu');
            if (link?.classList.contains('active')) {
                link.classList.remove('active');
                if (submenu) {
                    submenu.style.display = 'none';
                }
            }
            // Always reset nested child-submenus within this top-level item
            if (submenu) {
                resetChildSubmenus(submenu);
            }
        });
    };

    // Handle mobile menu clicks (top-level)
    menuItems.forEach(item => {
        const link = item.querySelector('.nav-link');
        const submenu = item.querySelector('.submenu');

        if (link && submenu) {
            link.addEventListener('click', (e) => {
                if (item.classList.contains('dropdown')) {
                    e.preventDefault();
                    link.classList.toggle('active');
                    slideToggle(submenu, 500, 'flex');

                    // If we just closed this submenu, also reset its child-submenus
                    if (!link.classList.contains('active')) {
                        resetChildSubmenus(submenu);
                    }

                    // Close other open top-level menus (and reset their nested children)
                    menuItems.forEach(otherItem => {
                        if (otherItem !== item) {
                            const otherLink = otherItem.querySelector('.nav-link');
                            const otherSubmenu = otherItem.querySelector('.submenu');
                            if (otherLink?.classList.contains('active')) {
                                otherLink.classList.remove('active');
                                slideToggle(otherSubmenu, 500, 'flex');
                                resetChildSubmenus(otherSubmenu);
                            }
                        }
                    });
                }
            });
        }
    });

    // Handle mobile menu clicks (child level - child-submenu)
    const childItems = document.querySelectorAll('.submenu .has-child');
    childItems.forEach(childItem => {
        const childLink = childItem.querySelector('.child-nav-link');
        const childSubmenu = childItem.querySelector('.child-submenu');

        if (childLink && childSubmenu) {
            childLink.addEventListener('click', (e) => {

                    e.preventDefault();
                    childLink.classList.toggle('active');
                    slideToggle(childSubmenu, 500, 'flex');

                    // Close sibling child-submenus within the same parent submenu
                    const parentList = childItem.parentElement; // the parent .submenu
                    if (parentList) {
                        Array.from(parentList.children)
                            .filter(el => el !== childItem && el.classList?.contains('has-child'))
                            .forEach(sibling => {
                                const sLink = sibling.querySelector('.child-nav-link');
                                const sSubmenu = sibling.querySelector('.child-submenu');
                                if (sLink?.classList.contains('active')) {
                                    sLink.classList.remove('active');
                                    slideToggle(sSubmenu, 500, 'flex');
                                }
                            });
                    }
            });
        }
    });

  desktopClose?.addEventListener('click', function(e) {
      hamburger.classList.remove('active');
      siteLogo.classList.remove('active');
      siteHeader.classList.remove('active');
      mobileNav.classList.remove('active');
      initBodyScroll();
      closeAllMenuItems();

      if (navScrollInstance) {
        navScrollInstance.destroy();
        navScrollInstance = null;
      }
  });

    // Handle hamburger menu
    hamburger?.addEventListener('click', function(e) {
        if (hamburger.classList.contains('active')) {
            hamburger.classList.remove('active');
            siteLogo.classList.remove('active');
            siteHeader.classList.remove('active');
            mobileNav.classList.remove('active');
            initBodyScroll();
            closeAllMenuItems();

            if (navScrollInstance) {
                navScrollInstance.destroy();
                navScrollInstance = null;
            }
        } else {
            siteHeader.classList.remove('sticky', 'fixed');

            if (window.matchMedia('(max-width: 1279px)').matches) {
              window.scrollTo({ top: 0, behavior: 'instant' });
            }

            hamburger.classList.add('active');
            siteLogo.classList.add('active');
            siteHeader.classList.add('active');
            mobileNav.classList.add('active');


            killBodyScroll();

            if (navWrapper && !navScrollInstance) {
              navScrollInstance = OverlayScrollbars(navWrapper, {
                scrollbars: {
                  autoHide: 'never',
                },
              });

          }

        }
    });

    // Handle resize
    let resizeTimer;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
            if (window.matchMedia('(min-width: 1280px)').matches) {
                closeAllMenuItems();
            }
            // Keep header search buttons in sync on resize
            try { updateSearchButtons(); } catch (_) {}
        }, 250);
    });

    // Close navigation when clicking outside on desktop
    document.addEventListener('click', (e) => {
        if (window.matchMedia('(min-width: 1280px)').matches) {
            const isClickInsideNav = mobileNav?.contains(e.target);
            const isClickOnHamburger = hamburger?.contains(e.target);

            if (!isClickInsideNav && !isClickOnHamburger && siteHeader?.classList.contains('active')) {
                hamburger.classList.remove('active');
                siteLogo.classList.remove('active');
                siteHeader.classList.remove('active');
                mobileNav.classList.remove('active');
                initBodyScroll();
                closeAllMenuItems();

                if (navScrollInstance) {
                    navScrollInstance.destroy();
                    navScrollInstance = null;
                }
            }
        }
    });

    // Header scroll behavior
    const header = document.querySelector('.site-header');
    const footerBar = document.querySelector('.footer-bar');
    const footerBarClose = document.querySelector('.footer-bar__close');
    const siteFooter = document.querySelector('.site-footer');

    if (footerBar && Cookies.get('footer_bar_closed')) {
        footerBar.classList.add('disabled');
    }

    if (footerBarClose) {
        footerBarClose.addEventListener('click', function() {
            Cookies.set('footer_bar_closed', 'true', { expires: 1 });

            if (footerBar) {
                footerBar.classList.add('disabled');
            }
        });
    }

    if (header) {
        const headerHeight = header.offsetHeight;
        let lastScrollTop = 0;

        const handleHeaderScroll = () => {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const scrollingDown = scrollTop > lastScrollTop;

            // Check if footer is visible
            const isFooterVisible = () => {
                if (!siteFooter) return false;
                const footerRect = siteFooter.getBoundingClientRect();
                const windowHeight = window.innerHeight;
                return footerRect.top <= windowHeight;
            };

            // Add fixed class after 2x header height
            if (scrollTop > headerHeight * 2) {
                header.classList.add('fixed');

                // Handle footer bar
                if (footerBar) {
                    if (scrollingDown && !isFooterVisible()) {
                        footerBar.classList.add('sticky');
                    } else {
                        footerBar.classList.remove('sticky');
                    }
                }
            } else {
                header.classList.remove('fixed');
                if (footerBar) {
                    footerBar.classList.remove('sticky');
                }
            }

            // Add sticky class when scrolling up and past 4x header height
            if (!scrollingDown && scrollTop > headerHeight * 4) {
                header.classList.add('sticky');
            } else {
                header.classList.remove('sticky');
            }

            lastScrollTop = scrollTop;
        };

        // Throttle scroll event
        let ticking = false;
        window.addEventListener('scroll', () => {
            if (!ticking) {
                window.requestAnimationFrame(() => {
                    handleHeaderScroll();
                    ticking = false;
                });
                ticking = true;
            }
        });
    }
});
